import { AfterViewInit, Component, ViewContainerRef, inject, viewChild, Signal } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { DrawerService } from '@app/shared/services/drawer/drawer.service';

@Component({
	selector: 'new-drawer',
	templateUrl: './new-drawer.component.html',
	styleUrls: ['./new-drawer.component.scss'],
	standalone: false
})
export class NewDrawerComponent implements AfterViewInit {
	private drawerService = inject(DrawerService);

	readonly drawer: Signal<MatDrawer> = viewChild.required<MatDrawer>('drawer');
	readonly drawerContentContainer: Signal<ViewContainerRef> = viewChild.required('drawerContentContainer', {
		read: ViewContainerRef
	});

	ngAfterViewInit() {
		this.drawerService.registerDrawer(this.drawer(), this.drawerContentContainer());
	}

	public close(): void {
		this.drawerService.close();
	}
}
